import BASEURLPROJETOS from '../api/projetos'
import { payloadCadastrarBacklog } from '../../interfaces/backlog'

export function cadastrarBacklogController(payload: payloadCadastrarBacklog) {
  return BASEURLPROJETOS.post('/projetos/backlog', payload)
}

export function listarBacklogController(idProjeto: string) {
  return BASEURLPROJETOS.get(`/projetos/backlog/${idProjeto}`)
}
